export default "__VITE_ASSET__243e51df__"